import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
  standalone: false
})
export class BreadcrumbsComponent {
  
  @Input() breadcrumbs: any;

  constructor(
    private router: Router
  ) {}

  ngOnInit() {}

  navigate(breadcrumb: any) {
    this.router.navigate([breadcrumb.route]);
  }
}